import React, { memo } from 'react';
import { Carousel } from 'react-bootstrap';
import { ConsultantCard } from '../../Molecules/ConsultantCard/ConsultantCard.jsx';
import { UseSliceContentBreakpoint } from '../../../Core/Hooks/HooksGenerals/UseSliceContentBreakpoint';
import '../../../Generals/Styles/CarouselLT.css';
import './ConsultantCarousel.css';
import TitleYellow from '../../Atoms/TitleYellow/TitleYellow.jsx';

const ConsultantCarousel = ({ consultantList, parameters, justConsultant, nameCourse = '' }) => {
  const { slicedContentList } = UseSliceContentBreakpoint(consultantList);

  return (
    <section>
      <TitleYellow
        className="text-center"
        title={parameters?.[justConsultant ? 'KNOW_CONS_LABEL' : 'QAA_LABEL']?.value}
        titleYellow={!justConsultant && parameters?.QAA_LABEL?.description_value}
      />
      <Carousel className="consultant-carousel" indicators={true} controls={false} interval={15000}>
        {slicedContentList.map((carouselContentList, index) =>
          carouselContentList.map((content, index) => (
            <Carousel.Item key={index}>
              <ConsultantCard key={index} {...{ content, justConsultant, nameCourse }} />
            </Carousel.Item>
          ))
        )}
      </Carousel>
    </section>
  );
};

export default memo(ConsultantCarousel);
